export enum FACT_NAMES_DATE {
  DATE_STABLISHED = "DATE_STABLISHED",
}
